import { Component } from '@angular/core';
import * as fromServices from '../../../services';

@Component({
  selector: 'hdw-about-migrants-seasonal',
  templateUrl: './about-migrants-seasonal.component.html',
  styleUrls: ['./about-migrants-seasonal.component.scss']
})
export class AboutMigrantsSeasonalToolComponent {
   public refreshDate: string;
    constructor(private locationFactory: fromServices.LocationFactoryService){
       this.locationFactory.getMSHSRefreshDate().then(refreshDateResponse => {
        this.refreshDate = refreshDateResponse.refreshDate
      });
    }
}
